import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies';
import VueClipboard from 'vue-clipboard2'
import globalfunc from './utils/globalfunc';
import Vant from 'vant'
import '@/assets/font/font.css';
import 'vant/lib/index.css';

createApp(App).use(store).use(router).use(Vant).use(globalfunc).use(VueCookies).use(VueClipboard).use(Vant).mount('#app')
